import React from 'react';
import { CreditSubmission, FinanceProgram, InsuranceQuote } from '@trnsact/trnsact-shared-types';
import { Nullable } from 'global';
import { LenderRequirementsDisplayWithFinanceProgramAndSubmission } from './LenderRequirementsDisplay/LenderRequirementsDisplayWithFinanceProgramAndSubmission';
import { LenderRequirementsDisplayWithManualInsuranceQuoteData } from './LenderRequirementsDisplay/LenderRequirementsDisplayWithManualInsuranceQuoteData';

interface Props {
  selectedSubmission: Nullable<CreditSubmission>;
  selectedFinanceProgram: Nullable<FinanceProgram>;
  insuranceQuote: Nullable<InsuranceQuote>;
  onEnterRequirements?: () => void;
}

export const LenderRequirementsDisplaySection = ({
  selectedSubmission,
  selectedFinanceProgram,
  insuranceQuote,
  onEnterRequirements,
}: Props) => {
  return selectedSubmission || selectedFinanceProgram ? (
    <LenderRequirementsDisplayWithFinanceProgramAndSubmission
      selectedSubmission={selectedSubmission}
      selectedFinanceProgram={selectedFinanceProgram}
    />
  ) : (
    <LenderRequirementsDisplayWithManualInsuranceQuoteData
      insuranceQuote={insuranceQuote}
      onEnterRequirements={onEnterRequirements}
    />
  );
};
